

















import { defineComponent } from '@vue/composition-api';

const name = 'ttam-question-tooltip';
export default defineComponent({
  props: {
    placement: {
      type: String,
      default: 'top',
    },
    effect: {
      type: String,
      default: 'light',
    },
    maxWidth: {
      type: String,
      default: '400px',
    },
  },
  setup() {
    return {
      name,
    };
  },
});
